import { render, staticRenderFns } from "./SideMenuPlayground.vue?vue&type=template&id=4b9a2649&scoped=true&"
import script from "./SideMenuPlayground.vue?vue&type=script&lang=js&"
export * from "./SideMenuPlayground.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuPlayground.vue?vue&type=style&index=0&id=4b9a2649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a2649",
  null
  
)

export default component.exports